import { useParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';

import { Buttons } from '@/components';
import ClientOnly from '@/components/client-only';
import { getFollowByAddress, postFollowById } from '@/services/follow';
import type { UserFollow } from '@/types/user';

const FollowInfo: React.FC<{
  follow: UserFollow;
  isOwner: boolean;
  userId: number;
}> = ({ follow, isOwner, userId }) => {
  const [follwer, setFollower] = useState<number>(follow.numberOfFollowers);
  const [isFollowing, setIsFollowing] = useState<boolean>(follow.isFollowing);
  const { address } = useParams();

  const getInfoFollow = async () => {
    if (typeof address !== 'string') return;
    const res = await getFollowByAddress(address);
    const { data } = res;
    setIsFollowing(data.isFollowing);
  };

  useEffect(() => {
    setFollower(follow.numberOfFollowers);
  }, [follow.numberOfFollowers]);

  useEffect(() => {
    address && getInfoFollow();
  }, [address]);

  const onFollowSubmit = async (isFL: boolean) => {
    setIsFollowing(!isFL);
    if (isFL) setFollower((pre) => pre - 1);
    else setFollower((pre) => pre + 1);
    userId && (await postFollowById(userId));
  };

  return (
    <div className="w-[270px] items-center rounded-xl border-1 border-gray-200 px-[26px] py-[20px] sm:mt-5 sm:w-full">
      <div className="flex items-center justify-between">
        <div className="m-0 text-[13px] text-[#9DA3B5]">Followers</div>
        <div className="text-[18px] font-[600] text-[#181818]">{follwer}</div>
      </div>
      <div className="flex items-center justify-between pt-4">
        <div className="m-0 text-[13px] text-[#9DA3B5]">Following</div>
        <div className="text-[18px] font-[600] text-[#181818]">{follow.numberOfFollowings}</div>
      </div>
      {!isOwner && (
        <ClientOnly>
          <Buttons
            onClick={() => onFollowSubmit(isFollowing)}
            typeBtn={isFollowing ? 'cancel' : 'primary'}
            className="m-auto -mb-2 mt-2 flex h-[43px] min-w-[112px]"
          >
            {isFollowing ? 'Following' : 'Follow'}
          </Buttons>
        </ClientOnly>
      )}
    </div>
  );
};

export default FollowInfo;
